import { useTranslation } from 'react-i18next'

import './header.component.scoped.scss'

export default () => {
  const { t } = useTranslation('socialNetworksPage')

  return (
    <header className="header-social-networks py-5">
      <h4 className="m-5 mb-5 mx-3 text-left" style={{ color: 'var(--white)' }}>
        {t('benefits')}
      </h4>
    </header>
  )
}
